export const parseQuery = (queryLikeString: string) => {
    if (!queryLikeString) {
        return {}
    }

    const queryParts = queryLikeString.split("&")
    const partsCount = queryParts.length
    let partsIndex = 0
    const parameters = {}

    for (; partsIndex < partsCount; partsIndex++) {
        const paramData = queryParts[partsIndex].split("=")
        // @ts-expect-error old code
        parameters[paramData[0]] = paramData[1] || true
    }

    return parameters
}
